import React from 'react'
import { Bubble, Button, ButtonSentiment } from 'sidecar-components'

export const AdditionalInsurance = ({ testId }) => {
  const buttonUrl =
    '/help/accessing-your-health-plan/how-does-sidecar-health-handle-coordination-of-benefits-cob'
  const title =
    'Your additional insurance cannot be used along with cash prices we find'
  return (
    <Bubble
      sentiment={ButtonSentiment.NOTIFY}
      testId={testId}
      canDismiss={false}
      title={title}
    >
      <p>
        It's better for you to find a provider in your other insurance's
        network.
      </p>
      <Button
        sentiment={ButtonSentiment.NOTIFY}
        path={buttonUrl}
        // making this external so the link opens a new tab
        // we don't want the user to lose their place
        pathType="external"
      >
        Learn more
      </Button>
    </Bubble>
  )
}
